import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  container: {
    display: "flex",
    height: "100%",
    width: "100%",
    backgroundColor: COLORS.greyBackground,
  },
  sidebar: {
    width: "20%",
    height: "100%",
    background: COLORS.white,
    minWidth: 200,
    borderRight: `1px solid ${COLORS.greyLight}`,
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 99,
  },
  outlet: {
    width: "80%",
  },
  outletContainer: {
    flex: 1,
  },
};

export default styles;
